// extracted by mini-css-extract-plugin
export default {"img":"QR_img__RDgo-"};